import parsePhoneNumber from 'libphonenumber-js'

/** @title Formats a phone-number for displaying.
 * @description !!! Only use this for displaying purposes !!!
 * @description By default it assumes it is a dutch phonenumber
 * If a proper country code (i.e. "+49" for DE) is provided it will format it as a german number
 * @example formatPhoneNumber(31612345678) // 06 12345678 (dutch number)
 * @example formatPhoneNumber('31493691234') // 0493 691 234 (dutch number)
 * @example formatPhoneNumber('+3221234567') // +32 2 123 45 67 (belgian number)
 * @example formatPhoneNumber('+496912345678') // +49 69 12345678 (german number)
 * */
export const displayPhoneNumber = (phoneNumber: string | number): string | undefined => {
    if (!phoneNumber) return

    const stringPhoneNumber = String(phoneNumber)

    const parsed = stringPhoneNumber.startsWith('+')
        ? parsePhoneNumber(stringPhoneNumber)
        : parsePhoneNumber('+' + phoneNumber)

    if (parsed) {
        if (parsed.country === 'NL') return parsed.formatNational()
        return parsed?.formatInternational()
    }

    return stringPhoneNumber
}
